import { render, staticRenderFns } from "./ConfirmTuvSyncModal.vue?vue&type=template&id=7e363c9c"
import script from "./ConfirmTuvSyncModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmTuvSyncModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports